import { type FC, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import BackButton from 'components/BackButton';
import Loader from 'components/Loader';
import { StepProps } from 'components/Stepper/types';
import useTeamMembersInvitationQuota from 'features/Team/hooks/useTeamMembersInvitationQuota';
import { useQuickInvitations } from 'features/Team/pages/MembersInvite/hooks/useQuickInvitations';
import * as Layout from 'layouts/StickyStepperLayout';

import * as routes from '../../../../../../routes';
import { useMemberInviteState } from '../../../MemberInviteProvider';
import LegalBeneficiarySelectorForm from './LegalBeneficiarySelectorForm';

const LegalBeneficiarySelector: FC<StepProps> = ({ goNext }) => {
  const history = useHistory();

  const { dispatch } = useMemberInviteState();

  const cancelFlow = () => {
    history.push(routes.members);
  };

  const {
    canBuyExtraSeats,
    loading: teamMembersInvitationQuotaLoading,
    teamMemberInvitationsQuota,
  } = useTeamMembersInvitationQuota();

  const { limit: invitationsLimit } = teamMemberInvitationsQuota;

  const isFreeRolesOnly = invitationsLimit === 1 && !canBuyExtraSeats;

  const { loading: quickInvitationsLoading, quickInvitations } =
    useQuickInvitations();
  const isLoading =
    teamMembersInvitationQuotaLoading || quickInvitationsLoading;

  useEffect(() => {
    if (!isLoading && (isFreeRolesOnly || quickInvitations.length === 0)) {
      dispatch({
        payload: false,
        type: 'SET_SHOULD_SHOW_LB_FORM',
      });
      if (isFreeRolesOnly) {
        dispatch({
          payload: true,
          type: 'SET_ACCOUNTANT_ONLY',
        });
      }
      goNext();
    }
  }, [isFreeRolesOnly, isLoading, dispatch, goNext, quickInvitations]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Layout.Root>
      <Layout.Body>
        <Layout.HeaderButtonsContainer>
          <BackButton onClick={cancelFlow} />
        </Layout.HeaderButtonsContainer>
        <LegalBeneficiarySelectorForm
          handleCancel={cancelFlow}
          legalBeneficiaries={quickInvitations}
          onSubmit={() => {
            goNext();
          }}
        />
      </Layout.Body>
    </Layout.Root>
  );
};

export default LegalBeneficiarySelector;
